import { FETCH_SERVICES_LIST  } from "../../actions/actionTypes";

const initialState = {
    data: [],
    isLoading: false,
    next:null
};

const reducer = (state=initialState, action)=>{    
    switch(action.type){
        case FETCH_SERVICES_LIST.REQUEST:
            return {...state, isLoading: true}
        case FETCH_SERVICES_LIST.FAILURE:
            return {...state, isLoading:false}
        case FETCH_SERVICES_LIST.SUCCESS:     
        return {
            ...state,
            data: action.obj.isLoadMore ? [...state.data,...action.obj.data] : 
            action.obj.data,
            count: action.obj.count,
            next: action.obj.next,
            totalItems:action.obj.totalItems,
            isLoading:false
          };      
        default:
            return state
    }   
}

export default reducer;